export const FooterCSS = {
  link: {
    // textDecoration: "none",
    color: "#fff",
    borderBottom: "2px solid transparent",
    fontSize: "14pt",
  },
};
